export default __webpack_public_path__ + "static/media/2-friend-icon.2eee2ae1.svg";